import { render, staticRenderFns } from "./UserCreatePage.vue?vue&type=template&id=66fdb534&"
import script from "./UserCreatePage.vue?vue&type=script&lang=js&"
export * from "./UserCreatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports